const getChatbotConfigKey = () => {
  const environment = import.meta.env.VITE_APP_ENV || 'development';
  return `${environment}_chatbot_config`;
};

export const setChatbotToken = (token?: string | null) => {
  if (token) {
    localStorage.setItem('chatbot_token', token);
    localStorage.setItem(getChatbotConfigKey(), token);
  }
};

export const removeChatbotToken = () => {
  localStorage.removeItem('chatbot_token');
  localStorage.removeItem(getChatbotConfigKey());
};

const CHATBOT_SCRIPT_ID = 'chatbot-widget-script';

/**
 * Dynamically injects the chatbot-widget.js script into the DOM.
 * Supports loading from a local asset or an external URL.
 */
export const loadChatbotScript = () => {
  if (document.getElementById(CHATBOT_SCRIPT_ID)) return;

  const script = document.createElement('script');
  script.id = CHATBOT_SCRIPT_ID;
  script.src = '/chatbot/chatbot-widget.js'; // Served locally from the /public/chatbot/ folder
  script.async = true;
  script.defer = true;

  // Configure data-api-url dynamically from environment variables if defined
  const apiUrl = import.meta.env.VITE_CHATBOT_API_URL;
  if (apiUrl) {
    script.setAttribute('data-api-url', apiUrl);
  }

  document.body.appendChild(script);
};

/**
 * Removes the chatbot script and cleans up any DOM elements or iframe
 * containers created by the widget.
 */
export const unloadChatbotScript = () => {
  const script = document.getElementById(CHATBOT_SCRIPT_ID);
  if (script) {
    script.remove();
  }

  // Remove any widget wrapper/iframes/elements added by chatbot-widget.js
  const widgetContainers = document.querySelectorAll(
    'iframe[src*="chat"], [id*="chatbot"], [class*="chatbot"]'
  );
  widgetContainers.forEach((el) => el.remove());
};
